export const GEOLOCATION: PermissionName = "geolocation";
